
export { getLandingPage } from "./contentfulAPI/landingPage.fetchers"